import { useEffect, useState } from 'react';

export function useRelativeTime(timestamp: number | null): string {
  const [, force] = useState(0);

  useEffect(() => {
    if (timestamp === null) return undefined;
    const handle = setInterval(() => force((n) => n + 1), 5_000);
    return () => clearInterval(handle);
  }, [timestamp]);

  if (timestamp === null) return '';
  const seconds = Math.floor((Date.now() - timestamp) / 1000);
  if (seconds < 5) return 'now';
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return new Date(timestamp).toLocaleDateString();
}
